import type { TenantBranding } from '@buildex/module-contract';

/** Нейтральный брендинг до загрузки конфига тенанта */
export const DEFAULT_BRANDING: TenantBranding = {
  logoUrl: '',
  primaryColor: '#1971c2',
  colorScheme: 'light',
  radius: 'md',
};
